export default [
  { code: 0, value: 'Gratis' },
  { code: 1, value: 'De pago' },
  { code: 2, value: 'accessCode' }
]
